module.exports = __webpack_public_path__ + "img/chefs_1.77ed4912.png";